<template>
  <div class="container-fluid">
    <div class="row justify-content-center mt-5">
      <div class="col-md-4">
        <div class="form-card">
          <div class="form-card__header">
            <h6 class="form-card__title">
              <i class="bi bi-shield-lock"></i>
              Cambiar contraseña
            </h6>
          </div>

          <div class="form-card__body">
            <form @submit.prevent="submit">
              <div class="form-card__field">
                <label class="form-card__label" for="cp-email">Email</label>
                <input
                  id="cp-email"
                  name="email"
                  type="text"
                  class="form-control"
                  disabled
                  v-model="user.email"
                />
              </div>

              <div class="form-card__field">
                <label class="form-card__label" for="cp-password">Nueva contraseña</label>
                <input
                  id="cp-password"
                  name="password"
                  v-model="password"
                  type="password"
                  class="form-control"
                  placeholder="Nueva contraseña"
                  autocomplete="new-password"
                />
              </div>

              <div class="form-card__field">
                <label class="form-card__label" for="cp-password-confirm">Confirmar contraseña</label>
                <input
                  id="cp-password-confirm"
                  name="password_confirmation"
                  v-model="password_confirmation"
                  type="password"
                  class="form-control"
                  placeholder="Confirmar contraseña"
                  autocomplete="off"
                />
              </div>
            </form>
          </div>

          <div class="form-card__footer">
            <button type="button" class="form-card__btn form-card__btn--primary" @click="submit">
              <i class="bi bi-check-lg"></i>
              Modificar perfil
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      loading: false,
      password: '',
      password_confirmation: ''
    }
  },
  computed: {
    ...mapGetters({
      user: 'authUser/getUser',
    }),
  },
  methods: {
    submit(e) {
      this.loading = true;
      e.preventDefault();
      if(this.checkPassword() == false)
        alert('La contraseña no coincide');
      else {
        let vm = this;
        const userData = {
                            name: this.user.name,
                            email: this.user.email,
                            password: this.password,
                            password_confirmation: this.password_confirmation
                          };
        axios.post('/api/users/editpassword', userData)
          .then((response) => {
            if (response.data.success) {
              
              location.href="/logout";
              vm.loading = false;
            } else {
              alert(response.data.data);
              vm.loading = false;
            }
          }).catch((error) => {
            alert('error: '+error);
            vm.loading = false;
        })
      }
    },
    checkPassword(){
      const check = (this.password_confirmation == null || this.password_confirmation == '' || this.password == null || this.password == '' || this.password_confirmation != this.password)
      return !check
    }
  },

}
</script>

